export default __webpack_public_path__ + "static/media/logo-smartek-icone.59b51e81.svg";